import React, { FC } from 'react';
import { usePostComposer } from 'app/modules/posts/modules/post/components/composer/PostComposerProvider';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';
import AccordionWidgetIcon from 'app/modules/posts/components/accordionWidget/AccordionWidgetIcon';
import AccordionWidgetTitle from 'app/modules/posts/components/accordionWidget/AccordionWidgetTitle';
import { Chip, Field, Icon, TextArea } from '@kontentino/ui';
import PostComposerContentLocalPostsProfileSelect from 'app/modules/posts/modules/post/components/composer/postComposerLocalPosts/PostComposerContentLocalPostsProfileSelect';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import { useTranslation } from 'react-i18next';

type Props = {
  accordionProps?: Omit<
    React.ComponentProps<typeof AccordionWidget>,
    'title' | 'titleSuffix' | 'icon'
  >;
};

export const PostComposerLocalPosts: FC<Props> = () => {
  const { form, setForm } = usePostComposer();
  const { t } = useTranslation();

  if (!form.page.isGlobal) {
    return null;
  }

  return (
    <AccordionWidget
      title={<AccordionWidgetTitle variant="localPosts" />}
      icon={<AccordionWidgetIcon variant="localPosts" />}
      data-name="post-composer_local-posts"
      data-cy="post-composer_local-posts"
      titleSuffix={(isOpen) =>
        !isOpen &&
        form.note2 &&
        form.distributeToPageIds.length > 0 && (
          <Chip variant="grey">
            <Icon icon={faCheck} size="sm" />
          </Chip>
        )
      }
    >
      <div className="tw-flex tw-flex-col tw-gap-4">
        <div className="tw-flex tw-flex-col tw-gap-2">
          <Field.Group>
            <div className="tw-flex tw-items-center">
              <Field.Label>
                {t('globalPages.localPostInstructions')}
              </Field.Label>
            </div>
            <UserPermissionGate
              scopes={UserPermission.POST_EDIT_TEXT}
              deniedProps={{ disabled: true }}
            >
              <TextArea
                value={form.note2}
                onChange={(e) => setForm({ note2: e.target.value })}
                data-cy="post-composer_local-posts-instructions"
              />
            </UserPermissionGate>
          </Field.Group>
        </div>
        <UserPermissionGate scopes={UserPermission.GLOBAL_PAGE_ASSIGN_CHANNEL}>
          <Field.Group className="tw-mb-4">
            <Field.Label required>
              {t('globalPages.localProfilesSelectLabel')}
            </Field.Label>
            <PostComposerContentLocalPostsProfileSelect />
          </Field.Group>
        </UserPermissionGate>
      </div>
    </AccordionWidget>
  );
};
